import { Container, Dialog, Heading } from "@/components"
import useEditPlan from "./useEditPlan";
import { Button, Textarea } from "@/components/ui";
import { PreviewPlan } from "./PreviewPlan";
import { NormalView } from "./NormalView";

const EditPlan = () => {
  const {
    breadcrumbData,
    onPreviewPlan,
    previewPlan,
    showConfirmation,
    setShowConfirmation,
    onConfirmSubmit,
    onSubmitApproval,
    reason,
    onChangeReason,
    isUpdatePending,
    isPlanDraft,
    isTaskExist,
    onViewHierarchy,
    onViewTaskPlan
  } = useEditPlan();

  return (
    <Container>
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading title={breadcrumbData[breadcrumbData.length - 1]?.name || ''} breadcrumbData={breadcrumbData} />
        </div>
        <div className="flex flex-row items-center gap-3">
          {isPlanDraft ? <>
            <Button disabled={!isTaskExist} onClick={onSubmitApproval}>Submit For Approval</Button>
            <Button disabled={!isTaskExist} onClick={onPreviewPlan}>{previewPlan ? 'Back to Plan' : 'Preview Plan'}</Button>
          </> : <></>}
          <Button onClick={onViewHierarchy}>View Task Hierarchy</Button>
          <Button onClick={onViewTaskPlan}>View Task Plan</Button>
        </div>
      </div>


      {previewPlan || !isPlanDraft ? <PreviewPlan /> : <NormalView />}
      <Dialog
        open={showConfirmation}
        setOpen={setShowConfirmation}
        title="Submit For Approval?" 
        onSave={onConfirmSubmit}
        saveText="Submit"
        contentClassName="lg:!max-w-[500px] lg:w-[500px]"
        isLoading={isUpdatePending}
      >
        <div>
          Are you sure you want to submit this project plan for approval?
          If yes, please provide a brief reason for your submission below.
          <div className="mt-5">
            <Textarea value={reason} onChange={onChangeReason} placeholder="Enter your reason here" className="h-[300px]" />
          </div>
        </div>
      </Dialog>
    </Container>
  )
}

export default EditPlan;